module.exports = __webpack_public_path__ + "static/media/welcome-1-bg.21bcbd4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/App/welcome-1-bg.jpg
// module id = 132
// module chunks = 0